import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { getHealthEmoji, getHealthText } from '@/utils/formatters';
import { AlertCircle, CheckCircle, Clock } from 'lucide-react';

const ProjectHealthCard = ({ healthData }) => {
  const navigate = useNavigate();
  if (!healthData) {
    return <div>Загрузка...</div>;
  }

  const { total, green, yellow, red } = healthData;

  return (
    <Card data-testid="project-health-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span>🚦</span> Здоровье проектов
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="text-3xl font-bold">
            {total} <span className="text-lg text-gray-500">проектов</span>
          </div>

          <div className="space-y-3">
            {/* Green */}
            <div
              className="flex items-center justify-between p-3 bg-green-50 rounded-lg cursor-pointer hover:bg-green-100 hover:shadow-sm transition-all"
              data-testid="health-green"
              onClick={() => navigate('/projects?health=green')}
              title="Показать проекты в графике"
            >
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span className="font-medium">🟢 В графике</span>
              </div>
              <span className="text-2xl font-bold text-green-600">{green}</span>
            </div>

            {/* Yellow */}
            <div
              className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg cursor-pointer hover:bg-yellow-100 hover:shadow-sm transition-all"
              data-testid="health-yellow"
              onClick={() => navigate('/projects?health=yellow')}
              title="Показать проекты с риском"
            >
              <div className="flex items-center gap-2">
                <Clock className="w-5 h-5 text-yellow-600" />
                <span className="font-medium">🟡 Риск</span>
              </div>
              <span className="text-2xl font-bold text-yellow-600">{yellow}</span>
            </div>

            {/* Red */}
            <div
              className="flex items-center justify-between p-3 bg-red-50 rounded-lg cursor-pointer hover:bg-red-100 hover:shadow-sm transition-all"
              data-testid="health-red"
              onClick={() => navigate('/projects?health=red')}
              title="Показать критичные проекты"
            >
              <div className="flex items-center gap-2">
                <AlertCircle className="w-5 h-5 text-red-600" />
                <span className="font-medium">🔴 Критично</span>
              </div>
              <span className="text-2xl font-bold text-red-600">{red}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectHealthCard;
